module.exports = __webpack_public_path__ + "img/m8.2ac4a9e2.png";